import { CREATE_PAGE } from '@dtx-company/flow-codegen/src/page/mutations'
import {
  CreatePageMutation,
  CreatePageMutationVariables,
  Link,
  LinkInput
} from '@dtx-company/flow-codegen/src/page/generated.types'
import { FLOWCODE_ROOT } from '@dtx-company/true-common/src/constants/root'
import { isFileString } from '@dtx-company/true-common/src/utils/blob'
import { pageGqlFetcher } from '@dtx-company/inter-app/src/services/gqlFetcher'
import { removeNullsOnOptional } from '@dtx-company/true-common/src/utils/objects'

export const createFlowpage = async (
  variables: CreatePageMutationVariables['page'],
  tags?: Record<string, unknown>
): Promise<CreatePageMutation> => {
  return pageGqlFetcher<CreatePageMutation, CreatePageMutationVariables>(
    CREATE_PAGE,
    {
      page: variables
    },
    undefined,
    tags
  )
}

export const getFormattedLinks = (pageLinks: Link[]): LinkInput[] => {
  return removeNullsOnOptional(pageLinks)?.map(serializeLink) || []
}

export const createRedirectValue = (slugName: string): string => {
  if (!slugName) console.error({ label: 'ClaimPage', msg: 'No slugname returned' })
  return `${FLOWCODE_ROOT}/page/${slugName}`
}

/**
 * @todo use common serializeLink when types change from '@dtx-company/inter-app/src/redux/slices/pageEditor/util'
 */
const serializeLink = ({
  __typename,
  thumbNailImgUrl: _,
  actionData: a,
  order,
  ...rest
}: Link): LinkInput => ({
  ...rest,
  actionData:
    // Files should be uploaded in another step
    'link' in a && isFileString(a.link) ? { link: '' } : a,
  order: order ?? -1
})
